
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-317de15b\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ScenarioQuestionRecognition.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ScenarioQuestionRecognition.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-317de15b\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ScenarioQuestionRecognition.vue"),
  /* scopeId */
  "data-v-317de15b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/views/scenarios/depricated/ScenarioQuestionRecognition.vue
// module id = 186
// module chunks = 42